<template>
  <a-card title="选择审批人" class="card" :loading="loading">
    <a-form :form="form" layout="inline">
      <a-form-item label="账期调整审批人">
        <a-select
          allowClear
          showSearch
          style="width: 200px"
          option-filter-prop="children"
          v-decorator="$decorator('creditManager', '请选择账期调整审批人')"
        >
          <a-select-option
            v-for="manager in managerList"
            :key="manager.username"
          >
            {{ manager.name }} - {{ manager.username }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-card>
</template>

<script>
import { getManagerTermList } from '../apply/api'
import { getFieldsErrorList } from 'utils/util'
const FORM_NAME = 'selectApproval'
export default {
  name: 'SelectApproval',
  data() {
    return {
      loading: true,
      managerList: [],
      form: this.$form.createForm(this, { name: FORM_NAME }),
    }
  },
  mounted() {
    this.fetchManagerList()
  },
  methods: {
    async fetchManagerList() {
      try {
        const { data } = await getManagerTermList()
        this.managerList = data
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    },
    async validate() {
      try {
        const validateResult = await this.form.validateFields()
        const passed = !!validateResult
        if (passed) {
          // 校验通过，返回数据
          this.clearFieldsError()
          return validateResult
        }
      } catch (error) {
        console.error('选择审批人校验未通过')
      }
      // 校验未通过，获取未通过的项
      this._getFieldsErrorsList()
      return false
    },
    // 获取未通过校验的项
    _getFieldsErrorsList() {
      const fieldsError = getFieldsErrorList(
        this.form.getFieldsError(),
        FORM_NAME,
      )
      this.$emit('setSelectApprovalErrors', fieldsError)
    },
    clearFieldsError() {
      this.$emit('setSelectApprovalErrors', [])
    },
  },
}
</script>

<style></style>
